// extracted by mini-css-extract-plugin
export default {"table":"DataTable_table__dxkIH"};